import React from 'react'
import Header from './Header'
import { Footer } from './Footer1'
import Homeproduct1 from './Homeproduct1'
import Nav from './Nav'

const Allproduct = () => {
  return (
    <div>
       <Nav/>
        <Homeproduct1/>
        <Footer/>
    </div>
  )
}

export default Allproduct